<shared-ui-menu-select
  [isMobile]="appStateService.isMobileResolution()"
  [isRadioInline]="true"
  [placeholder]="placeholder() ?? ''"
  [items]="options()"
  [isCheckSelectedItem]="true"
  [title]="$any(selectedItem()?.title)"
  [value]="selectedItem()?.value ?? ''"
  (valueChange)="changeSelectedItem($any($event))"
  menuClass="form-select-menu w-[340px]"
></shared-ui-menu-select>
